<template>
  <div style="display: inline-block;">
    <span
      id="btn-filter"
      @click="showFilter()"
      @mouseover="openMenu('filter')"
      @mouseleave="hideMenu()"
      class="btn btn-muted"
      style="position: relative; padding-bottom: 9.5px; padding-top: 10.5px; border: none; margin-right: 5px;"
    >
      <font-awesome-icon icon="search" class="fa-sm text-muted mr-1" />
      {{ t('Search users') }}
      <font-awesome-icon
        v-if="$isFreePlan.includes($session.get('paid_plan')) ||
              $isLegacyFreePlan.includes($session.get('paid_plan'))"
        class="fa-lg new-upgrade-icon"
        icon="arrow-circle-up"
        color="#ff7d66"
      />
    </span>
    <!-- {{ filterList }} -->
    <!-- ################################# FILTER START ################################# -->
    <div
      class="dropdown-filter-menu align-middle font-weight-normal no-drag"
      v-on-clickaway="hideMenu"
      v-if="showMore === 'filter'"
      @mouseover="openMenu('filter')"
      @mouseleave="hideMenu()"
    >
      <div class="row">
        <div class="col-auto">
          <ul class="pb-2">
            <li class="text-first font-weight-bold" v-translate>Pages</li>
            <li
              @click="setFilterBar('Visited URL')"
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="paperclip" />{{
                t('Visited URL')
              }}
            </li>
            <li
              @click="setFilterBar('Landing URL')"
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="paperclip" />{{
                t('Landing URL')
              }}
            </li>
            <li
              @click="setFilterBar('Exit URL')"
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="paperclip" />{{
                t('Exit URL')
              }}
            </li>
            <li
              @click="setFilterBar('Referrer URL', true)"
              class="cursor-pointer highlight my-auto"
              v-bind:class="{ 'text-muted': notQualified }"
            >
              <font-awesome-icon class="mr-2" icon="paperclip" />{{
                t('Referrer URL')
              }}
              <span class="badge badge-highlight" v-if="notQualified"
                >Pro plan</span
              >
            </li>
          </ul>

          <ul class="pb-2">
            <li class="text-first font-weight-bold">
              {{ t('Recording Attributes') }}
            </li>
            <li
              @click="
                showMore = null
                filterKey = 'Click text'
                searchOption = '='
                searchText = 'is'
                focusText()
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="mouse-pointer" />{{
                t('Click on text')
              }}
            </li>
            <li
              @click="
                setFilterBar('Rage Click', true)
                datalist = 'rageclick'
              "
              class="cursor-pointer highlight"
              v-bind:class="{ 'text-muted': notQualified }"
            >
              <font-awesome-icon class="mr-2" icon="angry" />{{
                t('Rage Click')
              }}
              <span class="badge badge-highlight" v-if="notQualified"
                >Pro plan</span
              >
            </li>
            <!-- <li
              @click="
                showMore = null
                filterKey = 'Error click'
                searchOption = 'yes'
                searchText = 'has'
                composeFilter()
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="bug" />{{
                t('Error click')
              }}
            </li> -->
            <li
              @click="
                showMore = null
                filterKey = 'Uturn'
                searchOption = 'yes'
                searchText = 'has'
                composeFilter()
              "
              class="cursor-pointer highlight"
              v-bind:class="{ 'text-muted': notQualified }"
            >
              <img
                width="12"
                height="12"
                class="mr-2"
                src="../assets/img/uturn.png"
              />
              {{ t('U-turn') }}
              <span class="badge badge-highlight" v-if="notQualified"
                >Pro plan</span
              >
            </li>
            <li
              @click="setFilterBar('Session Duration')"
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="clock" />{{
                t('Session Duration')
              }}
            </li>
            <li
              @click="setFilterBar('Page Count')"
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="layer-group" />{{
                t('Page Count')
              }}
            </li>
            <li
              @click="
                setFilterBar('Favourite')
                datalist = 'favourite'
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="star" />{{ t('Favourite') }}
            </li>
          </ul>
        </div>
        <div class="col-auto">
          <ul class="pb-2">
            <li class="text-first font-weight-bold">{{ t('Device Info') }}</li>
            <li
              v-if="recordingFilter === true"
              @click="
                setFilterBar('Device')
                datalist = 'device'
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="desktop" />{{ t('Device') }}
            </li>
            <li
              @click="
                setFilterBar('Operating System')
                datalist = 'os'
              "
              class="cursor-pointer highlight"
            >
              <code
                class="font-weight-bold"
                style="color: var(--color); margin-right: 5px"
                >os</code
              >
              {{ t('Operating System') }}
            </li>
            <li
              @click="
                setFilterBar('Browser')
                datalist = 'browser'
              "
              class="cursor-pointer highlight"
            >
              <img
                src="../assets/img/browser.svg"
                class="mr-1"
                width="14px"
                height="14px"
                style="color: var(--color); margin-right: 5px"
              />
              {{ t('Browser') }}
            </li>
            <li class="">&nbsp;</li>
          </ul>
          <ul class="pb-2">
            <li class="text-first font-weight-bold" v-translate>UTM Tags</li>
            <li
              @click="setFilterBar('Campaign')"
              class="cursor-pointer highlight"
            >
              <img
                width="12"
                height="12"
                class="mr-2"
                src="../assets/img/tag.png"
              />{{ t('Campaign') }}
            </li>
            <li
              @click="setFilterBar('Source')"
              class="cursor-pointer highlight"
            >
              <img
                width="12"
                height="12"
                class="mr-2"
                src="../assets/img/tag.png"
              />{{ t('Source') }}
            </li>
            <li
              @click="setFilterBar('Medium')"
              class="cursor-pointer highlight"
            >
              <img
                width="12"
                height="12"
                class="mr-2"
                src="../assets/img/tag.png"
              />{{ t('Medium') }}
            </li>
            <li @click="setFilterBar('Term')" class="cursor-pointer highlight">
              <img
                width="12"
                height="12"
                class="mr-2"
                src="../assets/img/tag.png"
              />{{ t('Term') }}
            </li>
          </ul>
        </div>

        <div class="col-auto">
          <ul class="pb-2">
            <li class="text-first font-weight-bold">
              {{ t('User Attributes') }}
            </li>
            <!-- <li @click="setFilterBar('Country')" class="cursor-pointer highlight"><font-awesome-icon class="mr-2" icon="map-marker-alt" /> Country</li> -->
            <li
              @click="
                showMore = null
                filterKey = 'Name'
                searchOption = '='
                searchText = 'is'
                focusText()
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="signature" />{{ t('Name') }}
            </li>

            <li
              @click="
                showMore = null
                filterKey = 'Email'
                searchOption = '='
                searchText = 'is'
                focusText()
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="at" />{{ t('Email') }}
            </li>

            <li
              @click="
                showMore = null
                filterKey = 'Visitor ID'
                searchOption = '='
                searchText = 'is'
                focusText()
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="user-tag" />{{
                t('Visitor ID')
              }}
            </li>

            <li
              @click="
                setFilterBar('Identified')
                datalist = 'identified'
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="user-tag" />{{
                t('Identified User')
              }}
            </li>

            <li
              @click="
                setFilterBar('IP Address')
                datalist = 'IP Address'
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="globe" />{{
                t('IP Address')
              }}
            </li>

            <li
              @click="
                setFilterBar('Location')
                datalist = 'userlocation'
              "
              class="cursor-pointer highlight"
            >
              <font-awesome-icon class="mr-2" icon="search-location" />{{
                t('Location')
              }}
            </li>
          </ul>

          <ul class="pb-2">
            <li class="text-first font-weight-bold">
              {{ t('Events Attribute') }}
            </li>
            <li
              @click="setFilterBar('Events', true)"
              class="cursor-pointer highlight"
              v-bind:class="{ 'text-muted': notQualified }"
            >
              <font-awesome-icon class="mr-2" icon="paperclip" />{{
                t('Events')
              }}
              <span class="badge badge-highlight" v-if="notQualified"
                >Pro plan
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="dropdown-filter-menu align-middle font-weight-normal no-drag"
      v-on-clickaway="hideMenu"
      v-if="showMore === 'filterOption'"
    >
      <div class="row">
        <div class="col-auto" width="300px">
          <ul class="pb-2">
            <li class="text-first font-weight-bold" v-translate>
              {{ filterKey }}
            </li>

            <template
              v-if="
                filterKey === 'Favourite' ||
                filterKey === 'Identified' ||
                filterKey === 'Rage Click'
              "
            >
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'yes'
                  searchText = 'is'
                  composeFilter()
                "
              >
                <font-awesome-icon class="mr-2" icon="check" />Yes
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'no'
                  searchText = 'is'
                  composeFilter()
                "
              >
                <font-awesome-icon class="mr-2" icon="times" />No
              </li>
            </template>
            <template v-else-if="filterKey === 'Device'">
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'desktop'
                  searchText = 'is'
                  composeFilter()
                "
              >
                Desktop
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'phone'
                  searchText = 'is'
                  composeFilter()
                "
              >
                Mobile
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'tablet'
                  searchText = 'is'
                  composeFilter()
                "
              >
                Tablet
              </li>
            </template>
            <template v-else-if="filterKey === 'Operating System'">
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'Windows'
                  searchText = 'is'
                  composeFilter()
                "
              >
                Windows
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'MacOS'
                  searchText = 'is'
                  composeFilter()
                "
              >
                MacOS
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'Linux'
                  searchText = 'is'
                  composeFilter()
                "
              >
                Linux
              </li>
            </template>
            <template v-else-if="filterKey === 'Browser'">
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'Chrome'
                  searchText = 'is'
                  composeFilter()
                "
              >
                Chrome
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'Firefox'
                  searchText = 'is'
                  composeFilter()
                "
              >
                Firefox
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'Safari'
                  searchText = 'is'
                  composeFilter()
                "
              >
                Safari
              </li>
            </template>
            <template v-else>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = '='
                  searchText = 'is'
                  focusText()
                "
                v-if="
                  !/URL$/.test(filterKey) && filterKey !== 'Session Duration'
                "
              >
                <font-awesome-icon class="mr-2" icon="check" />Is
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = '!='
                  searchText = 'is not'
                  focusText()
                "
                v-if="
                  !/URL$/.test(filterKey) &&
                  filterKey !== 'Page Count' &&
                  filterKey !== 'Session Duration' &&
                  filterKey !== 'Favourite'
                "
              >
                <font-awesome-icon class="mr-2" icon="times" />Is Not
              </li>

              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'LIKE'
                  searchText = 'contain'
                  focusText()
                "
                v-if="/URL$/.test(filterKey) && filterKey !== 'Page Count'"
              >
                <font-awesome-icon class="mr-2" icon="check" />Contain
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'NOTLIKE'
                  searchText = 'not contain'
                  focusText()
                "
                v-if="/URL$/.test(filterKey) && filterKey !== 'Page Count'"
              >
                <font-awesome-icon class="mr-2" icon="times" />Not Contain
              </li>

              <!-- <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = 'regex'
                  searchText = 'regex matches'
                  focusText()
                "
                v-if="/URL$/.test(filterKey) && filterKey !== 'Page Count'"
              >
                <font-awesome-icon class="mr-2" icon="percentage" />Regex
                Matches
              </li> -->
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = '>'
                  searchText = 'is more than'
                  focusText()
                "
                v-if="
                  filterKey === 'Page Count' || filterKey === 'Session Duration'
                "
              >
                <font-awesome-icon class="mr-2" icon="greater-than" />{{
                  t('Is More Than')
                }}
              </li>
              <li
                class="cursor-pointer highlight"
                @click="
                  showMore = null
                  searchOption = '<'
                  searchText = 'is less than'
                  focusText()
                "
                v-if="
                  filterKey === 'Page Count' || filterKey === 'Session Duration'
                "
              >
                <font-awesome-icon class="mr-2" icon="less-than" />{{
                  t('Is Less Than')
                }}
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="dropdown-filter-menu-text font-weight-normal no-drag"
      v-on-clickaway="hideMenu"
      v-if="showMore === 'criteriaInput'"
      style="width: 500px"
    >
      <div class="row">
        <div class="col-md-12 custom-form">
          <p>Search {{ filterKey }}</p>
          <input
            @click="showEvent = true"
            id="filterValue"
            autocomplete="false"
            class="form-control"
            @keyup.enter="composeFilter()"
            :placeholder="
              'Filter by ' +
              (filterKey ? filterKey : '...') +
              ' ' +
              (searchText && filterKey ? searchText + ' ...' : '')
            "
          />
          <div v-if="filterKey === 'Events'">
            <ul class="list-group mt-3">
              <li
                class="list-group-item cursor-pointer"
                @click="setEvent(item.event_text)"
                v-for="(item, key) in suggestion"
                :key="key"
              >
                <font-awesome-icon icon="mouse-pointer" class="mr-2 fa-sm" />
                {{ item.event_text }}
                <span class="float-right badge badge-light">{{
                  item.count
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- ################################# FILTER END ################################# -->
    <template v-if="filterList.some(item => item.name !== 'Watch status' && item.name !== 'Scorings') && !isPreSegment">
      <span
        v-if="Number($session.get('user_id')) !== 2572 && recordingFilter"
        class="btn btn-third text-primary"
        @click="saveSegment(filterList)"
        style="padding-top: 10px; padding-bottom: 8px"
        >{{ t('Add as segment') }}
      </span>
      <span
        v-if="showClearFilter"
        class="btn btn-link text-muted"
        @click="
          clearFilter()
        "
        >{{ t('Clear filter') }}</span
      >
    </template>

    <template v-if="filterList.length && !isPreSegment">
      <br />
      <div class="mt-4" style="position: absolute; left: 15; display: flex; flex-wrap: wrap;">
        <span class="space-bottom" v-for="(item, key) in filterList.filter(filterItem => filterItem.column !== 'watchStatus' && filterItem.column !== 'scoring')" v-bind:key="key">
          <span class="filter-tag no-drag text-muted2">
            <span v-if="item.name === 'Error click'">
              <b>{{ item.name }}</b> detected
            </span>
            <span v-else-if="item.name === 'Uturn'"> Has <b>U-Turn</b> </span>
            <span
              v-else-if="
                item.name !== 'Identified' &&
                item.name !== 'Rage Click' &&
                item.name !== 'Favourite'
              "
            >
              {{ formatHumanReadable(item.name) }}
              {{ item.conditionWord }} <b>{{ item.value }}</b>
              <span v-if="item.unit">{{ item.unitText }}</span>
            </span>
            <span v-else>
              User
              <span v-if="item.value === 'yes'">is</span>
              <span v-else>is not</span>
              <b>{{ item.name }}</b>
            </span>
            <font-awesome-icon
              v-if="!item.isNotEditable"
              class="cursor-pointer ml-1"
              icon="times"
              @click="removeFilter(item)"
            />
          </span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'FilterUser',
  components: {},
  props: ['isPreSegment', 'filterList', 'recordingFilter'],
  watch: {
    '$store.getters.datepicker.record': {
      handler: function (date) {
        this.setSuggestion()
      },
      deep: true
    }
  },
  data: function () {
    return {
      showMore: false,
      filterKey: '',
      searchOption: '',
      searchText: '',
      datalist: '',
      incrementId: 0,
      suggestion: [],
      showEvent: false,
      notQualified: false,
      savedFilterList: []
    }
  },
  mounted() {
    this.filterList = []
    this.setSuggestion()

    this.notQualified =
      this.$isFreePlan.includes(this.$session.get('paid_plan')) || // Free
      this.$isBasicPlan.includes(this.$session.get('paid_plan')) || // Basic
      this.$isGrowthPlan.includes(this.$session.get('paid_plan')) || // Growth
      this.$isLegacyFreePlan.includes(this.$session.get('paid_plan')) // Legacy Free

    if (this.$session.get('lifetimedeal')) this.notQualified = false

    /* moved URL query control at Record.vue */
    // let re = /\[(.*)\]/

    // setTimeout(() => {
    //   for (var key of Object.keys(this.$route.query)) {
    //     // console.log(key + ' -> ' + this.$route.query[key])
    //     let cond = key.match(re) ? key.match(re)[1] : '='
    //     this.composeFilter2(
    //       this.removeSquareBracket(key),
    //       cond.toUpperCase(),
    //       this.$route.query[key]
    //     )
    //   }
    // }, 500)
  },
  computed: {
    showClearFilter() {
      let check = this.filterList.find((x) => !x.isNotEditable)
      if (check) return true
      else return false
    }
  },
  methods: {
    clearFilter() {
      // prevent clearing recommendedSegments filter
      let tempFilterList = this.filterList.filter((x) => x.isNotEditable)
      let toClearList = this.filterList.filter((x) => !x.isNotEditable)
      toClearList.forEach((x) => {
        this.removeFilter(x)
      })
      this.filterList = []
      this.filterList = tempFilterList
      this.updateFilter()
    },
    showFilter() {
      if (
        !this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
        !this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))
      ) {
        this.showMore = 'filter'
      } else {
        this.$swal.fire({
          title: 'Upgrade your plan',
          text: 'This is a paid feature. Upgrade your plan to access more features.',
          type: 'warning',
          confirmButtonColor: '#2167f5'
        })
      }
    },
    setUrlParam(obj) {
      var query = { ...this.$route.query, ...obj }
      this.$router.replace({ query })
    },
    removeSquareBracket(x) {
      return x.replace(/\[.*/g, '')
    },
    setSuggestion() {
      this.$http
        .post(process.env.API_ENDPOINT + '/events/suggest', {
          widget_id: this.$session.get('widget_id'),
          event_type: 2,
          limit: 10,
          startDate: this.$store.getters.datepicker.record.startDate,
          endDate: this.$store.getters.datepicker.record.endDate
        })
        .then((response) => {
          this.suggestion = response.data
        })
    },
    setFilterBar(name, requireUpgrade = false) {
      if (this.notQualified && requireUpgrade) {
        this.$swal.fire({
          title: 'Upgrade to Pro plan',
          text: 'You need to upgrade your account to Pro plan and above to use this filter.',
          type: 'warning',
          confirmButtonColor: '#2167f5'
        })
      } else {
        this.datalist = ''
        this.showMore = 'filterOption'
        this.filterKey = name
      }
      // setTimeout(() => {
      //   document.getElementById('filter2').selectedIndex = 0
      // }, 100)
      // this.focusText()
    },
    openMenu(menu) {
      if (
        !this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
        !this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))
      ) {
        clearTimeout(window.menuTimeout)
        this.showMore = menu
      } else this.showMore = false
    },
    hideMenu() {
      clearTimeout(window.menuTimeout)
      window.menuTimeout = setTimeout(() => {
        this.showMore = null
      }, 100)
    },
    formatHumanReadable(x) {
      function titleCase(str) {
        var splitStr = str.toLowerCase().split(' ')
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
        }
        // Directly return the joined string
        return titleCase(splitStr.join(' '))
      }

      return x.replace(/_/g, ' ')
    },
    focusText() {
      this.showMore = 'criteriaInput'
      setTimeout(() => {
        try {
          document.getElementById('filterValue').focus()
        } catch (err) {}
      }, 200)
    },
    setEvent(x) {
      document.getElementById('filterValue').value = x
      this.composeFilter()
      this.showEvent = false
    },
    composeFilter() {
      setTimeout(() => {
        this.showMore = null
        let textbox = null
        try {
          textbox = document.getElementById('filterValue')
        } catch (err) {}
        this.isPreSegment = false

        this.incrementId++
        let filter = this.filterKey.trim()
        let condition = this.searchOption
        let conditionText = this.searchText
        let value = textbox ? textbox.value : '1'
        let allowMultipleList = ['Visited URL', 'Tags', 'Events']
        let endit = false

        if (filter === 'Favourite') value = condition === 'yes' ? 'yes' : 'no'
        if (
          filter === 'Device' ||
          filter === 'Operating System' ||
          filter === 'Browser'
        ) { value = this.searchOption }

        if (filter === 'Filter' || value.trim() === '') return

        let obj = {}
        let extraCondition = ''

        if (
          condition !== '=' &&
          !(
            filter === 'Device' ||
            filter === 'Operating System' ||
            filter === 'Browser'
          )
        ) { extraCondition = '[' + condition + ']' }

        obj[this.unifyKey(this.filterKey.trim()) + extraCondition] = value
        this.setUrlParam(obj)

        for (let i in this.filterList) {
          if (
            this.filterList[i].name === filter &&
            !allowMultipleList.includes(filter)
          ) {
            this.filterList[i].value = value
            if (this.filterList[i].unit) this.filterList[i].unit = 's' // document.getElementById('filter3').value
            endit = true
          }
        }

        if (!endit) {
          if (filter === 'Name') {
            this.filterList.push({
              column: 'name',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Email') {
            this.filterList.push({
              column: 'email',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Visitor ID') {
            this.filterList.push({
              column: 'uuid',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Visited URL') {
            this.filterList.push({
              column: 'location_' + this.incrementId,
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Landing URL') {
            this.filterList.push({
              column: 'landing',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Exit URL') {
            this.filterList.push({
              column: 'exit',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Campaign') {
            this.filterList.push({
              column: 'campaign',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Source') {
            this.filterList.push({
              column: 'source',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Medium') {
            this.filterList.push({
              column: 'medium',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Term') {
            this.filterList.push({
              column: 'term',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Referrer URL') {
            this.filterList.push({
              column: 'referral',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Session Duration') {
            this.filterList.push({
              column: 'duration',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value,
              unit: 's', // document.getElementById('filter3').value,
              unitText: 'Seconds' // document.getElementById('filter3').options[document.getElementById('filter3').selectedIndex].text
            })
          }

          if (filter === 'Tags') {
            this.filterList.push({
              column: 'tag_' + this.incrementId,
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Events') {
            this.filterList.push({
              column: 'events_' + this.incrementId,
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'IP Address') {
            this.filterList.push({
              column: 'ips_' + this.incrementId,
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Location') {
            this.filterList.push({
              column: 'userlocation',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Page Count') {
            this.filterList.push({
              column: 'pagecount',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Favourite') {
            this.filterList.push({
              column: 'starred',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: condition === 'yes' ? 'yes' : 'no'
            })
          }

          if (filter === 'Identified') {
            this.filterList.push({
              column: 'identified',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: condition === 'yes' ? 'yes' : 'no'
            })
          }

          if (filter === 'Rage Click') {
            this.filterList.push({
              column: 'rageclick',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: condition === 'yes' ? 'yes' : 'no'
            })
          }

          if (filter === 'Device') {
            this.filterList.push({
              column: 'device',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: this.searchOption
            })
          }

          if (filter === 'Operating System') {
            this.filterList.push({
              column: 'os',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: this.searchOption
            })
          }

          if (filter === 'Browser') {
            this.filterList.push({
              column: 'browser',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: this.searchOption
            })
          }

          if (filter === 'Country') {
            this.filterList.push({
              column: 'country',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'User ID') {
            this.filterList.push({
              column: 'uuid',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Error click') {
            this.filterList.push({
              column: 'errorclick',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Uturn') {
            this.filterList.push({
              column: 'uturn',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === 'Click text') {
            this.filterList.push({
              column: 'clicktext',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }
        }
        this.filterKey = ''
        this.searchOption = ''
        this.searchText = ''
        if (textbox) {
          textbox.value = ''
          textbox.blur()
        }

        this.updateFilter()
      }, 100)
    },
    unifyKey(x) {
      return x.toLowerCase().replace(/ /g, '_')
    },
    composeFilter2(filter, condition, value) {
      setTimeout(() => {
        this.showMore = null
        this.isPreSegment = false
        let conditionText = ''

        this.incrementId++
        let allowMultipleList = ['Visited URL', 'Tags', 'Events']
        let endit = false

        filter = this.unifyKey(filter)

        if (filter === this.unifyKey('Favourite')) { value = condition === 'yes' ? 'yes' : 'no' }

        // if (
        //   filter === 'Device' ||
        //   filter === 'Operating System' ||
        //   filter === 'Browser'
        // )
        //   value = searchOption

        if (filter === this.unifyKey('Filter') || value.trim() === '') return

        if (condition === '=') conditionText = 'is'
        if (condition === '!=') conditionText = 'is not'
        if (condition === '>') conditionText = 'more than'
        if (condition === '<') conditionText = 'less than'
        if (condition === 'NOTLIKE') conditionText = 'does not contain'
        if (condition === 'LIKE') conditionText = 'contains'

        for (let i in this.filterList) {
          if (
            this.filterList[i].name === filter &&
            !allowMultipleList.includes(filter)
          ) {
            this.filterList[i].value = value
            if (this.filterList[i].unit) this.filterList[i].unit = 's' // document.getElementById('filter3').value
            endit = true
          }
        }

        if (!endit) {
          if (filter === this.unifyKey('Name')) {
            this.filterList.push({
              column: 'name',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Email')) {
            this.filterList.push({
              column: 'email',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Visitor ID')) {
            this.filterList.push({
              column: 'uuid',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Visited URL')) {
            this.filterList.push({
              column: 'location_' + this.incrementId,
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Landing URL')) {
            this.filterList.push({
              column: 'landing',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Exit URL')) {
            this.filterList.push({
              column: 'exit',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Campaign')) {
            this.filterList.push({
              column: 'campaign',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Source')) {
            this.filterList.push({
              column: 'source',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Medium')) {
            this.filterList.push({
              column: 'medium',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Term')) {
            this.filterList.push({
              column: 'term',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Referrer URL')) {
            this.filterList.push({
              column: 'referral',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Session Duration')) {
            this.filterList.push({
              column: 'duration',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value,
              unit: 's', // document.getElementById('filter3').value,
              unitText: 'Seconds' // document.getElementById('filter3').options[document.getElementById('filter3').selectedIndex].text
            })
          }

          if (filter === this.unifyKey('Tags')) {
            this.filterList.push({
              column: 'tag_' + this.incrementId,
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Events')) {
            this.filterList.push({
              column: 'events_' + this.incrementId,
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('IP Address')) {
            this.filterList.push({
              column: 'ips_' + this.incrementId,
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Location')) {
            this.filterList.push({
              column: 'userlocation',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Page Count')) {
            this.filterList.push({
              column: 'pagecount',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Favourite')) {
            this.filterList.push({
              column: 'starred',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: condition === 'yes' ? 'yes' : 'no'
            })
          }

          if (filter === this.unifyKey('Identified')) {
            this.filterList.push({
              column: 'identified',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: condition === 'yes' ? 'yes' : 'no'
            })
          }

          if (filter === this.unifyKey('Rage Click')) {
            this.filterList.push({
              column: 'rageclick',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: condition === 'yes' ? 'yes' : 'no'
            })
          }

          if (filter === this.unifyKey('Device')) {
            this.filterList.push({
              column: 'device',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Operating System')) {
            this.filterList.push({
              column: 'os',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Browser')) {
            this.filterList.push({
              column: 'browser',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Country')) {
            this.filterList.push({
              column: 'country',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('User ID')) {
            this.filterList.push({
              column: 'uuid',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Error click')) {
            this.filterList.push({
              column: 'errorclick',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Uturn')) {
            this.filterList.push({
              column: 'uturn',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }

          if (filter === this.unifyKey('Click text')) {
            this.filterList.push({
              column: 'clicktext',
              condition: condition,
              conditionWord: conditionText,
              name: filter,
              value: value
            })
          }
        }

        this.updateFilter()
      }, 100)
    },
    updateFilter() {
      this.$emit('change', this.filterList)
    },
    removeFilter(item) {
      for (let i = this.filterList.length - 1; i >= 0; i--) {
        let current = this.filterList[i]
        if (current === item) this.filterList.splice(i, 1)
      }

      // let key2delete =
      //   this.unifyKey(item.name) +
      //   (item.condition !== '=' ? '[' + item.condition + ']' : '')

      let key2delete = this.unifyKey(item.name)

      const query = Object.assign({}, this.$route.query)
      console.log(query)
      delete query[key2delete]
      console.log('remove', key2delete)
      this.$router.replace({ query })

      this.updateFilter()
    },
    saveSegment(filterList) {
      this.$swal
        .fire({
          title: 'Save new segment as...',
          input: 'text',
          inputValue: '',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .post(process.env.API_ENDPOINT + '/segment/add', {
                name: result.value,
                filter: JSON.stringify(filterList),
                widget_id: this.$session.get('widget_id'),
                user_id: this.$session.get('user_id')
              })
              .then(() => {
                this.$emit('loadSegment')
                this.$swal.fire({
                  title: 'Success',
                  text: 'The new segment has been added successfully.',
                  type: 'success',
                  confirmButtonColor: '#2167f5'
                })

                this.$auditlog({ module: 'usage', action: 'save_recording_segment' })  
        
                try{
                  howuku.track('usage', { feature: 'save_recording_segment' })
                }catch(e){}
          
                try{
                  _cio.track('usage', { feature: 'save_recording_segment', created_at: Math.round(new Date().getTime() / 1000) })
                }catch(e){}                     
              })
          } else if (!result.dismiss) {
            this.$swal.fire({
              title: 'Name cannot be empty.',
              text: 'Please try again.',
              type: 'error',
              confirmButtonColor: '#2167f5'
            })
          }
        })
    }
  }
}
</script>

<style>
.space-bottom {
  margin-bottom: 20px;
}

.dropdown-filter-menu-text {
  position: absolute;
  background-color: var(--background);
  margin-top: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 0px 0px;
  text-align: left;
  z-index: 2000;
}

.dropdown-filter-menu {
  position: absolute;
  background-color: var(--background);
  /* min-width: 400px; */
  margin-top: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 0px 0px;
  text-align: left;
  z-index: 2000;
  /* margin-top: 50px; */
}

.dropdown-filter-menu li {
  display: block;
  padding: 3px 30px;
  clear: both;
  white-space: nowrap;
  font-weight: 400;
  font-size: 12px;
  color: var(--color);
  line-height: 30px;
  background-color: transparent;
  text-align: left;
}

.dropdown-filter-menu ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 0px !important;
}

.highlight:hover {
  background-color: rgba(var(--main-color), 0.1);
}

.custom-form {
  padding: 20px 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/FilterUser.vue